export const ligasdeinteres_item = [
    {
      "ligasdeinteres_item_nombre" : "Comité de Ética y Prevención de Conflictos de interés",
      "ligasdeinteres_item_url" : "/Ligasdeinteres/Etica"
    },
    {
      "ligasdeinteres_item_nombre" : "Comité de Control y Desempeño Institucional",
      "ligasdeinteres_item_url" : "/Ligasdeinteres/Cocodi"
    },
    {
      "ligasdeinteres_item_nombre" : "Convocatorias",
      "ligasdeinteres_item_url" : "/Ligasdeinteres/Convocatorias"
    },
    {
      "ligasdeinteres_item_nombre" : "Avisos de Privacidad",
      "ligasdeinteres_item_url" : "/AvisosPrivacidad"
    },
   
    {
      "ligasdeinteres_item_nombre" : "Directorio Digital de Personas Artesanas",
      "ligasdeinteres_item_url" : "https://spsfa.amigosdelatransformacion.com.mx/"
    },
];